var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");
var ui_extensions = require("ui-extensions");

var Camera3dView  = require("./camera3dView.js");
var Camera3dModel = require("./camera3dModel.js");
var Camera3dStateMachine = require("./camera3dStateMachine.js");

var Editor3d = require("./../editor3d/editor3dController.js");
var Selection3d = require("./../selection3d/selection3dController.js");

var Camera3dController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
    this.buttons = options.buttons;

    lib_core.GuiEvents.addEvents({
        CAMERA_SWITCH: {id: 'cam_1', name: "CAMERA_SWITCH", isGuiButton: true}
    });
};

lib_core.inherit(Camera3dController, lib_core.Controller);
Camera3dController.inject = {
    editor3d : Editor3d,
    tabController : ui_extensions.TabController
};

module.exports = Camera3dController;

Camera3dController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    if(this.buttons){
        this.tabController.getView().registerButton({
            name: 'CamSwitch',
            title: 'Switch Camera',
            sortOrder: 2,
            eventType: lib_core.GuiEvents.CAMERA_SWITCH,
            style: {
                icon: 'icon-workplane.svg',
            },
            group: "camera"
        });
    }
};

Camera3dController.prototype.createModel = function () {
    return new Camera3dModel(this.configuration);
};

Camera3dController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();
    
    return new Camera3dView(this.getModel(), editor3dView);
};

Camera3dController.prototype.createStateMachine = function () {
    return new Camera3dStateMachine(this.root, this.getModel());
};

